import { createPortal } from "react-dom";
import { getPortalLayerTarget } from "./portalRoot";

const Portal = ({ children, layer = "modal" }) => {
  const target = getPortalLayerTarget(layer);
  if (!target || !children) return null;
  return createPortal(children, target);
};

export default Portal;
